import { t } from '../../../../utils/textUtils';

export const formatDate = (dateString) => {
  if (!dateString) return t('TIDAK DITENTUKAN');
  const date = new Date(dateString);
  return date.toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

export const formatCurrency = (amount) => {
  if (!amount) return t('TIDAK DITENTUKAN');
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0
  }).format(amount);
};

export const getDisplayName = (value, fallback = t('TIDAK DITENTUKAN')) => {
  if (!value) return fallback;
  if (typeof value === 'object') {
    return value.fullName || value.username || value.name || fallback;
  }
  return value;
};

export const formatStatus = (status) => {
  if (!status) return 'Planning';
  switch (status) {
    case 'planning': return 'Planning';
    case 'in_progress': return 'In Progress';
    case 'on_hold': return 'On Hold';
    case 'cancelled': return 'Cancelled';
    case 'completed': return 'Completed';
    case 'closed': return 'Closed';
    case 'retention': return 'Retention';
    default:
      return status.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'planning':
    case 'planned':
      return '#3949AB';
    case 'in_progress':
    case 'ongoing':
      return '#00897B';
    case 'on_hold':
    case 'paused':
      return '#FB8C00';
    case 'cancelled':
    case 'terminated':
      return '#E53935';
    case 'completed':
    case 'finished':
      return '#43A047';
    case 'retention':
      return '#9C27B0';
    case 'closed':
    case 'archived':
      return '#757575';
    default:
      return '#3949AB';
  }
};

export const getSiteEngineerNames = (project) => {
  if (Array.isArray(project?.siteEngineers) && project.siteEngineers.length > 0) {
    return project.siteEngineers
      .map(se => se.fullName || se.username)
      .filter(Boolean);
  }
  if (project?.siteEngineer) {
    return [getDisplayName(project.siteEngineer, t('BELUM DITUGASKAN'))];
  }
  return [];
};

export const getCurrentEngineerIds = (project) => {
  if (Array.isArray(project?.siteEngineers) && project.siteEngineers.length > 0) {
    return project.siteEngineers.map(se => se.id).filter(Boolean);
  }
  if (project?.siteEngineerId) {
    return [project.siteEngineerId];
  }
  return [];
};

export const triggerFileDownload = (fileData, fileName) => {
  if (!fileData) return;
  const blob = fileData instanceof Blob ? fileData : new Blob([fileData]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
